export default __webpack_public_path__ + "static/media/004-judo.3eb872b3.svg";